import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { PlanForm } from "../PlanForm";
import { EditPlanModalProps } from "./types";
import { useEditPlanModal } from "./controller";

export const EditPlanModal = React.memo(
  ({ modalRef, onComplete, agreement }: EditPlanModalProps) => {
    const translate = useTranslate();

    const { methods, handleSubmit, isPending } = useEditPlanModal(
      modalRef,
      onComplete,
      agreement
    );


    return (
      <Modal
        ref={modalRef}
        title={translate("subscription_plan_admin.titles.edit")}
        onConfirm={handleSubmit}
        methods={methods}
        isPending={isPending}
      >
        <PlanForm agreement={agreement} />
      </Modal>
    );
  }
);
